import { useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';
import classes from 'classnames';
import { DispatcherEvents, EventDispatcherContext } from '@/context/eventDispatcherContext';

export interface BackdropProps {
  className?: string;
  style?: {};
  emitClose?: () => void;
}

const AppBackdropPortal = ({ className, style, emitClose }: BackdropProps) => {
  const eventDispatcher = useContext(EventDispatcherContext);

  useEffect(() => {
    eventDispatcher.dispatch(DispatcherEvents.APP_BACKDROP_SHOWN, null);
  }, [eventDispatcher]);

  return (
    <div className={classes('app-backdrop', className)} style={style} onClick={emitClose}></div>
  );
};

const AppBackdrop = ({ className, style, emitClose }: BackdropProps) => {
  const backdropPortalElement = document.getElementById('backdrop_portal') as Element;

  const backdropPortal = ReactDOM.createPortal(
    <AppBackdropPortal className={className} style={style} emitClose={emitClose} />,
    backdropPortalElement
  );

  return <>{backdropPortal}</>;
};

export default AppBackdrop;
